import React from "react";

const AppContext = React.createContext();
const PageContext = React.createContext();

export { AppContext, PageContext };
